export const BRAND_ID = 'CB8A5D86-E849-4137-92E2-56E29C6A8B18';

